import { Component, Input } from '@angular/core';
import { BaseEdit } from '../base-edit';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'ldw-text-edit',
    templateUrl: './text-edit.component.html',
    styleUrls: ['./text-edit.component.css'],
    standalone: false
})
export class TextEditComponent extends BaseEdit {
  @Input() clearButtonEnabled = true;

  clearText() {
    this.internalControl?.reset('');
  }
}
